import React, { useState, useEffect } from 'react';
import { useAsync } from 'react-use';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-zero/react';
import { combineActions } from 'redux-zero/utils';
import { DsCard, DsIcon } from '@tokenyico/design-system/dist/reactJS';
import { orderBy } from 'lodash';
import classnames from 'classnames';

import { MessageService } from 'services';

import MessagesList from './MessagesList';
import MessageDetail from './MessageDetail';

import { formActions, holderActions } from 'app/state/actions';
import { toast } from '@tokenyico/design-system';

const MessagesView = ({ holder: { messages, selectedToken }, setMessages, history }) => {
  const { t } = useTranslation();
  const [selectedMessage, setSelectedMessage] = useState();
  const [showMessageList, setShowMessageList] = useState(false);
  const [dataMessages, setDataMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const EmptyState = () => {
    const { t } = useTranslation();
    return (
      <div className="empty-state">
        <div className="empty-state__icon">
          <DsIcon name="message" size="2.5rem" />
        </div>
        <div className="empty-state__title">{t('emptyState.noMessages.title')}</div>
        <div className="empty-state__body">{t('emptyState.noMessages.body')}</div>
      </div>
    );
  };

  useAsync(async () => {
    const messageList = await MessageService.getAllMessages(selectedToken.address);
    setMessages(messageList);
    setSelectedMessage(null);
    setDataMessages(orderBy(messageList, 'date', 'desc'));
    if (messageList.length > 0) {
      setSelectedMessage(messageList[0]);
    }
    setIsLoading(false);
  });

  useEffect(() => {
    //** Messages feature is disabled temporally. Guard the messages route and inform the user*/
    history.push('/');
    toast.info('Info', t('shared.disableMessagesHelper'), 5000);
    /***********/
    setDataMessages(orderBy(messages, 'date', 'desc'));
  }, [messages]);

  return (
    <div className="messages _my-4">
      <DsCard shadowDistance={2} padding={0} className="_flex:column">
        <div
          className="_flex:row _flex:justify(space-between) _p(4)"
          style={{ width: '100%', borderBottom: '1px solid var(--grey-400)' }}
        >
          <span onClick={() => setShowMessageList(!showMessageList)} className="inbox-toggle">
            <DsIcon name="list" size="1.25rem" color="var(--blue-500)" />
            &nbsp;&nbsp;{t('shared.messagesAll')}
          </span>
        </div>
        <div className="messages__body">
          {isLoading === false && dataMessages.length === 0 ? (
            <EmptyState />
          ) : (
            <>
              <div
                className={classnames('messages__list', { 'show-messages': showMessageList })}
                style={{ backgroundColor: 'var(--grey-200)' }}
              >
                <MessagesList
                  messages={dataMessages}
                  selectedMessage={selectedMessage}
                  setSelectedMessage={setSelectedMessage}
                  setShowMessageList={setShowMessageList}
                  isLoading={isLoading}
                />
              </div>
              <div className={classnames('messages__detail', { 'show-messages': showMessageList })}>
                <MessageDetail selectedMessage={selectedMessage} />
              </div>
            </>
          )}
        </div>
      </DsCard>
    </div>
  );
};

const mapToProps = (state) => state;
export default connect(mapToProps, combineActions(formActions, holderActions))(MessagesView);
